import {
  HoverableLink,
  HoverableLinkProps,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'
import { Userpilot } from 'userpilot'

type ResourceCenterAnalyticsProps = {
  event: string
  properties?: Record<string, unknown>
}

type ResourceCenterLinkProps = Omit<
  HoverableLinkProps,
  'href' | 'ariaLabelSource' | 'ariaLabel'
> & {
  analytics?: ResourceCenterAnalyticsProps
}

const ResourceCenterLink: React.FC<
  React.PropsWithChildren<ResourceCenterLinkProps>
> = (props): React.ReactElement => {
  const { analytics } = useAnalyticsContext()
  return (
    <HoverableLink
      {...props}
      css={css`
        font-family: ${styleConstants.fontFamilies.regular};
      `}
      onClick={(): void => {
        Userpilot.trigger('resource_center:jNfDAOvnub')
        if (props.analytics) {
          analytics.track(props.analytics.event, props.analytics.properties)
        }
      }}
      ariaLabelSource={'Resource Center'}
    >
      {props.children || <Trns source={'Resource Center'} />}
    </HoverableLink>
  )
}

export default ResourceCenterLink
